<template>

  <aside class="cookie-banner pt-4 pb-4 text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h2>Hey <span class="icon-hand-peace"></span></h2>
          <p>
            Um dir Features wie <b>Musik-Player, Videos und Events</b> anzuzeigen,
            nutzen wir die externen Dienste <i>Mixcloud, Soundcloud, Youtube, Vimeo und Facebook</i>.<br>
            Dafür musst du Cookies zulassen.
          </p>
          <p class="pb-2 text-small">
            Mehr dazu in unserer <router-link target="_blank" to="/datenschutz">Datenschutzerklärung</router-link>.
          </p>
          <div class="btn btn--secondary" @click="denyCookies()">Nee, lieber nicht</div>
          <div class="btn btn--primary" @click="allowCookies()">Ok, her damit</div>
        </div>
      </div>
    </div>
  </aside>

</template>

<script>

  export default {
    name: 'CookieBanner',
    data: function() {
      return {
        cookies: false
      }
    },
    mounted() {
      const close = (e) => {
        const ESC = 27;
        if (e.keyCode !== ESC) return;
        this.$emit('close');
      };
      document.addEventListener('keyup', close);
      this.$on('hook:destroyed', () => {
        document.removeEventListener('keyup', close);
      });
      this.$on('hook:destroyed', () => {
        this.deactivate();
      });
      this.init();
    },
    methods: {
      init() {
        this.disableScrolling();
        this.inert();
        this.checkCookie();
      },
      async deactivate() {
        this.enableScrolling();
        await this.inert(false);
      },
      disableScrolling() {
        this.scrollPosition = window.pageYOffset;
        const $body = document.querySelector('body');
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${this.scrollPosition}px`;
        $body.style.width = '100%';
      },
      enableScrolling() {
        const $body = document.querySelector('body');
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        $body.scrollTop =  this.scrollPosition;
      },
      async inert(status = true) {
        await this.$nextTick();
        [...this.$root.$el.children].forEach((child) => {
          if (child === this.$el || child.contains(this.$el)) return;
          child.inert = status;
        });
      },
      allowCookies() {
        this.$emit('cookies',true);
        this.$emit('banner',false);
        this.setCookie(true);
        this.enableScrolling();
      },
      denyCookies() {
        this.$emit('cookies',false);
        this.$emit('banner',false);
        this.setCookie(false);
        this.enableScrolling();
      },
      setCookie: function(v) {
        this.cookies = v;
        var d = new Date();
        d.setTime(d.getTime() + (90*24*60*60*1000)); // first val = days
        var expires = "expires="+ d.toUTCString();
        document.cookie = 'allowCookies='+v+';path=/;'+expires;
        if (this.cookies) {
          setTimeout(function(){FB.XFBML.parse()},100);
        }
      },
      getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      checkCookie: function() {
        var c = this.getCookie('allowCookies');
        if (c === "") {
          this.$emit('banner',true);
        } else {
          this.$emit('banner',false);
          this.$emit('cookies',JSON.parse(c.toLowerCase()));
          this.cookies = JSON.parse(c.toLowerCase());
        }
      }
    }
  }
</script>

<style>

  .cookie-banner {
    display: flex;
    align-content: flex-end;
    z-index: 30;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0,0,0,.9);
    font-size: 1.25rem;
    line-height: 1.3;
    color: #fff;
  }
  .cookie-banner .container {
    align-self: flex-end;
  }
  .cookie-banner p {
    color: #fff;
  }
  .cookie-banner p a {
    text-decoration: underline;
  }
  .cookie-banner .btn {
    width: 100%;
  }

  @media ( min-width: 768px ) {
    .cookie-banner .btn {
      width: auto;
      margin-right: 2rem;
    }
  }

</style>
